<template>
  <div class="dn-frontpage-top">
    <!-- eslint-disable vue/no-v-html -->
    <div
      class="dn-frontpage-content"
      v-html="html"
    />
  </div>
</template>

<script setup lang="ts">
const { getFrontPageData } = useFrontPage();
const { data: frontpageData } = await useAsyncData('frontpageData', () => getFrontPageData('indexPage'));
const cssUrl = frontpageData?.value?.cssUrl;
const html = frontpageData?.value?.html;
useHead({
  link: [{ rel: 'stylesheet', type: 'text/css', href: cssUrl }]
});
</script>
